export default "__VITE_ASSET__DTXrxZY8__"